import type { LeadFormStepFields as BasicLeadFormStepFields } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { faBuilding as fasBuilding, faComment as fasComment } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import { FormCurrency, FormInput, FormTextArea, ProgressButton } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

const MIN_LOAN_AMOUNT = 100_000;
const MAX_LOAN_AMOUNT = 1_000_000_000;

export interface LeadFormStepFields extends BasicLeadFormStepFields {
	loanAmount: number;
	companyName: string;
	question: string;
}

export class LeadForm extends BasicLeadForm<LeadFormStepFields> {
	protected renderContent(): ReactNode {
		const { submitState } = this.props;

		return (
			<>
				<Card.Header>
					<Card.Title className="text-center h4">Add meg adataidat, segítünk!</Card.Title>
				</Card.Header>
				<Card.Body>
					{this.renderFields()}
					{this.renderPrivacyStatement()}
				</Card.Body>
				<Card.Footer className="text-center">
					<ProgressButton state={submitState} type="submit" variant="gold" size="lg">
						Érdekelnek a részletek
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected renderFields(): ReactNode {
		return (
			<>
				{super.renderFields()}
				<FormCurrency name="loanAmount" placeholder="Hitelösszeg" validate={this.validLoanAmount} required />
				<FormInput
					name="companyName"
					prepend={<FontAwesomeIcon icon={fasBuilding} />}
					placeholder="Cégnév"
					validate={this.validCompanyName}
					required
				/>
				<FormTextArea name="question" prepend={<FontAwesomeIcon icon={fasComment} />} placeholder="Kérdés" />
			</>
		);
	}

	private validCompanyName(companyName: string): string {
		if (!companyName) {
			return "A cégnév megadása kötelező!";
		}

		if (companyName.length < 2) {
			return "A cégnév legalább 2 karakterből kell, hogy álljon!";
		}

		if (companyName.length > 40) {
			return "A cégnév legfeljebb 40 karakterből állhat!";
		}
	}

	private validLoanAmount(loanAmount: number): string {
		if (loanAmount < MIN_LOAN_AMOUNT) {
			return `A hitelösszeg nem lehet kevesebb mint ${formatText(MIN_LOAN_AMOUNT, "ft")}!`;
		}

		if (loanAmount > MAX_LOAN_AMOUNT) {
			return `A hitelösszeg nem lehet több mint ${formatText(MAX_LOAN_AMOUNT, "ft")}!`;
		}
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
